import { colorTokens } from '@rideiq/shared/components/variables';
import styled from 'styled-components';

const FlexContent = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 0.75rem;
  gap: 2.5rem;
  height: 40px;

  &:first-of-type {
    margin-top: 1.5rem;
  }
  &:last-of-type {
    margin-bottom: 0;
  }
`;

export const FieldWithLabel = styled(FlexContent)`
  > div {
    width: 75%;
  }
  > label {
    width: 9.37rem;
  }
`;

export const CloseButton = styled('div')`
  display: inline-flex;
  margin-left: auto;
  width: 20px;
  height: 20px;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  cursor: pointer;

  &:hover {
    background: #ddebfa;
    svg {
      color: ${colorTokens.text.hover};
    }
  }
`;
